import useGetLineFromCache from "hooks/apollo/line/useGetLineFromCache";
import useGetWorkBlockFromCache from "hooks/apollo/workBlock/useGetWorkBlockFromCache";

export default function useBlockFactory() {
  const workBlockBuilder = useWorkBlockBuilder();
  const downtimeBuilder = useDowntimeBuilder();

  return (block) => {
    if (block.__typename === "WorkBlock") {
      return workBlockBuilder(block);
    }
    return downtimeBuilder(block);
  };
}

function useWorkBlockBuilder() {
  const getWorkBlockFromCache = useGetWorkBlockFromCache();
  const getLineFromCache = useGetLineFromCache();

  return (block) => {
    const cachedWorkBlock = getWorkBlockFromCache(block.id);

    return {
      ...block,
      __typename: "WorkBlock",
      line: getLineFromCache(block.line.id),
      previousWorkTimeEndsAt: cachedWorkBlock?.workTimeEndsAt,
      previousWorkTimeStartsAt: cachedWorkBlock?.workTimeStartsAt,
    };
  };
}

function useDowntimeBuilder() {
  const getLineFromCache = useGetLineFromCache();

  return (block) => ({
    ...block,
    __typename: "DowntimeBlock",
    line: getLineFromCache(block.line.id),
  });
}
